export function verificationRecaptcha({ siteKey, locale, action, elementId = 'not-a-robot' }) {
  return {
    recaptchaToken: '',
    recaptchaSiteKey: siteKey,
    recaptchaLoaded: false,
    verificationAttempt: '',
    init() {
      if (this.recaptchaSiteKey) {
        this.loadRecaptcha();
      } else {
        console.error('Recaptcha site key is not defined.');
      }
    },
    loadRecaptcha() {
      // window.grecaptcha can already be loaded by another verification() instance on the
      // same page - render this instance's own widget immediately instead of assuming a
      // script load is still needed.
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        this.renderWidget();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=explicit&hl=${locale}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (!window.grecaptcha || !window.grecaptcha.enterprise) {
          console.error('reCAPTCHA enterprise is not available.');
          return;
        }
        this.renderWidget();
      }
      script.onerror = () => {
        console.error('Failed to load reCAPTCHA script.');
      }
      document.head.appendChild(script);
    },
    renderWidget() {
      window.grecaptcha.enterprise.ready(() => {
        this.recaptchaLoaded = true;
        this.waitForElement(`#${elementId}`).then(() => {
          grecaptcha.enterprise.render(elementId, {
            action,
            sitekey: this.recaptchaSiteKey,
            callback: (token) => {
              this.recaptchaToken = token;
            }
          });
        })
        .catch(console.error)
      });
    },
    checkVerificationCode(contact, countryCode) {
      return this.$api({
        url: '/verify_code',
        method: 'post',
        data: { verification: { contact, country_code: countryCode, verification_token: this.verificationAttempt } },
      });
    },

    sendVerificationCode(loginMethod, contact, countryCode, captchaToken) {
      return this.$api({
        url: '/send_verification_code_v2',
        method: 'post',
        data: { verification: { method: loginMethod, contact, country_code: countryCode, captcha_token: captchaToken } },
      });
    },

    waitForElement(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const start = performance.now();

        function check() {
          const el = document.querySelector(selector);
          if (el) return resolve(el);

          if (performance.now() - start > timeout) return reject(`Element ${selector} not found`);

          requestAnimationFrame(check);
        }

        check();
      });
    }
  };
}
